// extracted by mini-css-extract-plugin
export default {"field-form":"FieldForm_field-form__42PJ7","checkbox-container":"FieldForm_checkbox-container__yovld","tag":"FieldForm_tag__SoJk8","checkbox-label":"FieldForm_checkbox-label__Y8SqX"};